export function validateAttendingInput(value?: string): string | undefined {
  if (value === 'NO_RESPONSE' || !value) {
    return 'Required';
  }
  return undefined;
}

export function validateNameInput(
  value?: { firstName: string; familyName: string },
  allValues?: { attendingAnyEvents: boolean }
): { firstName?: string; familyName?: string } | undefined {
  if (value?.firstName && value?.familyName) {
    return undefined;
  }
  if (allValues?.attendingAnyEvents) {
    return {
      firstName: value?.firstName ? undefined : 'Required',
      familyName: value?.familyName ? undefined : 'Required',
    };
  }
  // yes, == is on purpose; want to catch null OR undefined
  if (value?.firstName == null || value?.familyName == null) {
    return {
      firstName: value?.firstName !== null ? undefined : 'Required',
      familyName: value?.familyName !== null ? undefined : 'Required',
    };
  }
  return undefined;
}

export function validateMealOption(value?: string): string | undefined {
  if (!value) {
    return 'Required';
  }
  return undefined;
}
